var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGarbage = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.116 3.691-.29.559H5.97c-.711 0-1.286.559-1.286 1.25s.575 1.25 1.286 1.25h15.428c.711 0 1.286-.559 1.286-1.25s-.575-1.25-1.286-1.25h-3.857l-.29-.559A1.285 1.285 0 0 0 16.104 3h-4.838c-.486 0-.932.266-1.149.691zM21.398 8H5.97l.852 13.242C6.886 22.23 7.73 23 8.746 23h9.876c1.017 0 1.86-.77 1.925-1.758L21.398 8z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGarbage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/garbage.31a24484.svg";
export { ForwardRef as ReactComponent };